export function countryList(state: any) {
    const { countries, countries_prefered } = state.configuration?.forms?.member?.profile || {}

    if (!countries) {
        return []
    }

    let countryList = Object.entries(countries).map(countryArray => ({
        label: countryArray[0],
        value: countryArray[1],
    }))

    if (countries_prefered.length > 0) {
        const preferedList: Array<any> = []

        countryList.unshift({ label: '---------', value: null })

        for (const preferedCountry of countries_prefered) {
            const foundCountry = countryList.find(c => c.value === preferedCountry)

            if (foundCountry) {
                preferedList.push(foundCountry)
            }
        }

        countryList = [...preferedList.sort((a, b) => a.label.localeCompare(b.label)), ...countryList]
    }

    return countryList
}

export function stateList(state: any) {
    const { states, states_prefered } = state.configuration?.forms?.member?.profile || {}

    if (!states) {
        return []
    }

    const stateList = Object.entries(states).map(stateArray => ({
        label: stateArray[0],
        value: stateArray[1],
    }))

    if (states_prefered.lenght > 0) {
        stateList.unshift({ label: '---------', value: null })

        for (const preferedState of states_prefered) {
            const foundState = stateList.find(c => c.value === preferedState)

            if (foundState) {
                stateList.unshift(foundState)
            }
        }
    }

    return stateList
}
